import './Foco-Bold.eot';
import './Foco-Bold.otf';
import './Foco-Bold.svg';
import './Foco-Bold.ttf';
import './Foco-Bold.eot';
import './Foco-Regular.eot';
import './Foco-Regular.otf';
import './Foco-Regular.svg';
import './Foco-Regular.ttf';
import './Foco-Regular.woff';
import './icomoon.eot';
import './icomoon.svg';
import './icomoon.ttf';
import './icomoon.woff';
import './ROHH-Akwe-Pro-Regular.eot';
import './ROHH-Akwe-Pro-Regular.svg';
import './ROHH-Akwe-Pro-Regular.ttf';
import './ROHH-Akwe-Pro-Regular.woff';
import './selection.json';



// WEBPACK FOOTER //
// ./assets/fonts/main.js